(function() {
    'use strict';

    angular
        .module('atheer.workspace', [

        ]);
})();
